import { render } from "./COIActionBarDeathCertificate.vue?vue&type=template&id=0173ea34"
import script from "./COIActionBarDeathCertificate.vue?vue&type=script&lang=js"
export * from "./COIActionBarDeathCertificate.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__